export default {
  baseURI: process.env.VUE_APP_BASE_URI,
  sessionTimeout: 10,
  multifactorAuthOn: false

  // https://536790cd-c8c1-4bdc-b349-a29c64ba3f92.mock.pstmn.io/api/member
  // http://localhost:9091/api/
  // http://192.168.0.28:9091/api/
}
